import { useEffect, useState } from "react";
import ReportType from "./ReportType";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useLazyExportFulfillmentCandidateReportDataQuery, useLazyGetFullfillmentCustomerbyTenantQuery, useSearchFullfillmentCandidateReportApiQuery } from "../report";
import { useGetAllTenantsQuery } from "../../../customer/tenantApi";
import { getCurrentMonthStartDate } from "../../../../helpers/utils/Utils";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";

const FulfillmentCandidateReport = () => {

    const tenantData = useGetAllTenantsQuery("");

    const [fulfillmentCustomerData, fulfillmentCustomerDataApi] = useLazyGetFullfillmentCustomerbyTenantQuery();
    const [type, setType] = useState('FULFILLMENT_CANDIDATE_REPORT');
    const [triggerExportReportDataQuery] = useLazyExportFulfillmentCandidateReportDataQuery();
    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Report Fulfillment Candidate");

    useEffect(() => {
        document.title = 'Fulfillment Candidate Report';
    }, []);

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Fulfillment Candidate Report", url: "" }]
    );

    const columns: DataTableColumn[] = [
        {
            label: "Order No.",
            accessor: "customerOrderNumber",
            visibility: { hasShowSetting: false },
            canSort: false,
            cell: (props: any) => {
                let path = "/orders/" + props.row.original.orderId;
                return <>
                    {
                        createClickableLink(path, props.value, userSetting)
                    }
                </>
            },
        },
        {
            label: "Fulfillment Candidate Name", accessor: "fulfillmentCandidateName", canSort: false,
            visibility: { hasShowSetting: false }
        },
        {
            label: "Tenant",
            accessor: "tenant",
            visibility: { hasShowSetting: false, canColumnShow: false },
            filterOptions: [{
                dependentColumns: ["Fulfillment Customer Name"],
                filterComponent: SearchSelectWithList(tenantData?.data, (tenant: { name: any; }) => `${tenant.name}`, "name", "Select Tenant...", false, "tenant"),
                overrideFilterAccessor: "tenant",
                overrideFilterLabel: "Tenant",
            }],
        },
        {
            label: "Fulfillment Customer Name",
            accessor: "fulfillmentCustomerName",
            visibility: { hasShowSetting: false },
            canSort: false,
            cell: (props: any) => {
                return <span>{props.value}</span>;
            },
            filterOptions: [{
                filterComponent: SearchSelectWithList(fulfillmentCustomerDataApi?.data, (customer: { customerName: any; customerNumber: any; }) => `${customer.customerName} (${customer.customerNumber})`, "id", "Select Fulfillment Customer(s)...", true, "customerIds"),
                onDependencyUpdated: (value: any) => {
                    fulfillmentCustomerData(value);
                },
                overrideFilterAccessor: "customerIds",
            }],

        },
        {
            label: "Created", accessor: "creationDate", visibility: { hasShowSetting: false, canColumnShow: false }, canSort: false,
            cell: (props: { value: any; }) => {
                return props.value ? formatValueAsDateAndTime(props.value, "MM/D/YYYY") : '';
            }, filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]
        },
        {
            label: "1st Delivered Date", accessor: "firstDeliveredDate", overrideSortColumn: "delivered_date",
            canSort: false,
            cell: (props: { row: { original: { firstDeliveredDate: any; }; }; }) => {
                return formatValueAsDateAndTime(props.row.original.firstDeliveredDate, 'MM/DD/YY h:mm a');
            },
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"deliveredDateFrom"} />,
                overrideFilterAccessor: "deliveredDateFrom",
                overrideFilterLabel: "Delivered Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"deliveredDateTo"} />,
                overrideFilterAccessor: "deliveredDateTo",
                overrideFilterLabel: "Delivered Date - To",
            }]

        },

        {
            label: "Fulfillment Fee", accessor: "fulfillmentFee", canSort: false
        },

    ];
    const customFilter = {
        createdDateFrom: getCurrentMonthStartDate(),
    }
    return (
        <>
            <div className="user-container px-4 py-2">
                <div className="flex justify-between">
                    <Breadcrumb crumbs={crumbs} />
                </div>
                <ReportType type={type} setType={setType} />
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchFullfillmentCandidateReportApiQuery,
                        exportAction: triggerExportReportDataQuery
                    }
                    }
                    defaultSortOptions={{
                        accessor: "creationDate",
                        direction: "asc"
                    }}
                    defaultFilter={
                        {
                            ...customFilter,
                            "pageNumber": 0,
                            "pageSize": "15",

                        }
                    }
                    userSettingGroup={"Report Fulfillment Candidate"}
                    basePermission={"FCANDR"}
                />
            </div>
            <div />
        </>
    )
}

export default FulfillmentCandidateReport;